// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Import semua halaman
import DashboardPage from './pages/DashboardPage';
import SummaryPage from './pages/SummaryPage';
import TransactionPage from './pages/TransactionPage';
import MasterDataPage from './pages/MasterDataPage';
import LoginPage from './pages/LoginPage';
import SyncPage from './pages/SyncPage';
import UserManagementPage from './pages/UserManagementPage';

import { useAuth } from './context/AuthContext'; // <-- Import useAuth
import './App.css';

// Komponen Spinner
const GlobalLoader = () => (
  <div className="global-loader-overlay">
    <div className="spinner"></div>
  </div>
);

// Komponen Layout untuk halaman yang memiliki Navbar
const AppLayout = ({ sidebarVisible, setSidebarVisible }) => (
  <div className="App">
    <Navbar className={sidebarVisible ? '' : 'collapsed'} onToggleSidebar={() => setSidebarVisible(!sidebarVisible)} />
    <main className={`content ${sidebarVisible ? '' : 'full-width'}`}>
      <Outlet />
    </main>
  </div>
);

function App() {
  const { isLoading } = useAuth(); // <-- Dapatkan state isLoading
  const [sidebarVisible, setSidebarVisible] = useState(true);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000} // Notifikasi hilang setelah 5 detik
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // Gunakan tema berwarna (hijau untuk sukses, merah untuk error)
      />
      {isLoading && <GlobalLoader />} {/* <-- Tampilkan loader jika isLoading */}
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="summary" element={<SummaryPage />} />
            <Route path="transaction" element={<TransactionPage />} />
            <Route
              path="master-data"
              element={
                <AdminRoute>
                  <MasterDataPage />
                </AdminRoute>
              }
            />
            <Route
              path="sync"
              element={
                <AdminRoute>
                  <SyncPage />
                </AdminRoute>
              }
            />
            <Route
              path="users"
              element={
                <AdminRoute>
                  <UserManagementPage />
                </AdminRoute>
              }
            />
          </Route>
          </Routes>
        </Router>
    </>
  );
}

export default App;